module.exports = __webpack_public_path__ + "static/media/guidr.39dcf4b4.png";